// extracted by mini-css-extract-plugin
module.exports = {"prothom-family":"protom-family-m__prothom-family__3Fuwq"};